import { createSlice } from '@reduxjs/toolkit'

export const inspectionSlice = createSlice({
  name: 'inspection',
  initialState: {
    token : '',
    menu : {}
  },
  reducers: {
    setToken: (state, {payload}) =>{
      state.token = payload;
    },
    setMenu: (state, {payload}) =>{
      state.menu = payload;
    },
    logout:(state)=>{
      state = this.initialState;
    }
  },
})
export const { setToken, setMenu, logout } = inspectionSlice.actions
export default inspectionSlice.reducer